import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import {
    FileModel,
    FileModelPagedResponseModel,
    CreateFileRequestModel,
    CheckOutFileRequestModel,
    CheckInFileRequestModel,
    QueryParams,
    ApiResponse
} from '../models';

/**
 * Files API Service
 */
@Injectable({
    providedIn: 'root'
})
export class FilesService extends BaseApiService {

    /**
     * Get all files with pagination
     */
    getFiles(params?: QueryParams): Observable<ApiResponse<FileModelPagedResponseModel>> {
        return this.get<FileModelPagedResponseModel>('/files', params);
    }

    /**
     * Get file by ID
     */
    getFileById(fileId: string): Observable<ApiResponse<FileModel>> {
        return this.get<FileModel>(`/files/${fileId}`);
    }

    /**
     * Create a new file
     */
    createFile(file: CreateFileRequestModel): Observable<ApiResponse<FileModel>> {
        return this.post<FileModel>('/files', file);
    }

    /**
     * Update file content
     */
    updateFileContent(fileId: string, content: string): Observable<ApiResponse<FileModel>> {
        return this.put<FileModel>(`/files/${fileId}/content`, { content });
    }

    /**
     * Check out file
     */
    checkOutFile(fileId: string, request: CheckOutFileRequestModel): Observable<ApiResponse<FileModel>> {
        return this.post<FileModel>(`/files/${fileId}/checkout`, request);
    }

    /**
     * Check in file
     */
    checkInFile(fileId: string, request: CheckInFileRequestModel): Observable<ApiResponse<FileModel>> {
        return this.post<FileModel>(`/files/${fileId}/checkin`, request);
    }

    /**
     * Lock file
     */
    lockFile(fileId: string): Observable<ApiResponse<FileModel>> {
        return this.post<FileModel>(`/files/${fileId}/lock`);
    }

    /**
     * Unlock file
     */
    unlockFile(fileId: string): Observable<ApiResponse<FileModel>> {
        return this.post<FileModel>(`/files/${fileId}/unlock`);
    }

    /**
     * Get files by project
     */
    getFilesByProject(projectId: string): Observable<ApiResponse<FileModel[]>> {
        return this.get<FileModel[]>(`/files/projects/${projectId}/files`);
    }

    /**
     * Get checked out files
     */
    getCheckedOutFiles(): Observable<ApiResponse<FileModel[]>> {
        return this.get<FileModel[]>('/files/checked-out');
    }

    /**
     * Get files by status
     */
    getFilesByStatus(status: number): Observable<ApiResponse<FileModel[]>> {
        return this.get<FileModel[]>(`/files/by-status/${status}`);
    }

    /**
     * Get file by path
     */
    getFileByPath(path: string): Observable<ApiResponse<FileModel>> {
        return this.get<FileModel>('/files/by-path', { path });
    }
}



